<vi-page [sidenavs]="true" [footer]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>

  <vi-content body [centered]="true">
    <vi-empty
      main
      gtm="onGoToPage"
      gtmAction="StatusType"
      gtmCategory="statusPage"
      gtmLabel="statusPage"
      [header]="statusPageHeader | translate"
      [content]="statusPageContent | translate"
      [imgSrc]="'/assets/img/status-failed-page.svg'"
    >
    </vi-empty>
  </vi-content>
  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
</vi-page>
